//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './MergeFieldClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type GetSingleMergeFieldQueryParameters = {
  id: number ;
}

export type PatchMergeFieldQueryParameters = {
  id: number ;
}

export type RemoveMergeFieldQueryParameters = {
  id: number ;
}


export function getUrl(): string {
  let url_ = getBaseUrl() + "/api/document/merge-fields";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.MergeFieldDto[], unknown, Types.MergeFieldDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.MergeFieldDto[], unknown, Types.MergeFieldDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'MergeFieldClient',
      'get',
    ]);
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
axiosConfig    );
}

/**
 * Gets all merge fields.
 */
export function useGetQuery<TSelectData = Types.MergeFieldDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.MergeFieldDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.MergeFieldDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MergeFieldDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.MergeFieldDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.MergeFieldDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all merge fields.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.MergeFieldDto[] | undefined) => Types.MergeFieldDto[], ) {
  queryClient.setQueryData(getQueryKey(),
    updater
  );
}

/**
 * Gets all merge fields.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MergeFieldDto[] | undefined) => Types.MergeFieldDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/document/merge-fields";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'MergeFieldClient',
      'create',
    ]);
}

/**
 * Creates a merge field.
 * @param dto Request parameter
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.MergeFieldDto, unknown, Types.CreateMergeFieldDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MergeFieldDto, unknown, Types.CreateMergeFieldDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateMergeFieldDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getSingleUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/document/merge-fields/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSingleDefaultOptions: Omit<UseQueryOptions<Types.MergeFieldDto, unknown, Types.MergeFieldDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.MergeFieldDto, unknown, Types.MergeFieldDto>, 'queryFn'>> = {
};
export function getGetSingleDefaultOptions() {
  return getSingleDefaultOptions;
};
export function setGetSingleDefaultOptions(options: typeof getSingleDefaultOptions) {
  getSingleDefaultOptions = options;
}

export function getSingleQueryKey(id: number): QueryKey;
export function getSingleQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetSingleMergeFieldQueryParameters;

    return trimArrayEnd([
        'MergeFieldClient',
        'getSingle',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'MergeFieldClient',
        'getSingle',
        ...params
      ]);
  }
}
export function __getSingle(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSingle(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetSingleQuery<TSelectData = Types.MergeFieldDto, TError = unknown>(dto: GetSingleMergeFieldQueryParameters, options?: Omit<UseQueryOptions<Types.MergeFieldDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a merge field by id.
 * @param id The merge field id.
 */
export function useGetSingleQuery<TSelectData = Types.MergeFieldDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.MergeFieldDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSingleQuery<TSelectData = Types.MergeFieldDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MergeFieldDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetSingleMergeFieldQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.MergeFieldDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSingle(context, axiosConfig) : __getSingle,
    queryKey: getSingleQueryKey(id),
    ...getSingleDefaultOptions as unknown as Omit<UseQueryOptions<Types.MergeFieldDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets a merge field by id.
 * @param id The merge field id.
 */
export function setGetSingleData(queryClient: QueryClient, updater: (data: Types.MergeFieldDto | undefined) => Types.MergeFieldDto, id: number) {
  queryClient.setQueryData(getSingleQueryKey(id),
    updater
  );
}

/**
 * Gets a merge field by id.
 * @param id The merge field id.
 */
export function setGetSingleDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MergeFieldDto | undefined) => Types.MergeFieldDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/document/merge-fields/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'MergeFieldClient',
      'patch',
      id as any,
    ]);
}

/**
 * Edits a merge field.
 * @param id The merge field id.
 * @param dto Request parameter
 */
export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.UpdateMergeFieldDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateMergeFieldDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateMergeFieldDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchMergeFieldQueryParameters & {
  dto: Types.UpdateMergeFieldDto;
}

/**
 * Edits a merge field.
 * @param id The merge field id.
 * @param dto Request parameter
 */
export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchMergeFieldQueryParameters}): UseMutationResult<void, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/document/merge-fields/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'MergeFieldClient',
      'remove',
      id as any,
    ]);
}

/**
 * Removes a merge field.
 * @param id The merge field id.
 */
export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveMergeFieldQueryParameters

/**
 * Removes a merge field.
 * @param id The merge field id.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveMergeFieldQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function importUrl(): string {
  let url_ = getBaseUrl() + "/api/document/merge-fields/import";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function importMutationKey(): MutationKey {
  return trimArrayEnd([
      'MergeFieldClient',
      'import',
    ]);
}

/**
 * Imports a merge field (overwrites existing merge field with the same Prefix and Code, if exists).
 */
export function useImportMutation<TContext>(options?: Omit<UseMutationOptions<Types.MergeFieldDto, unknown, Types.ImportMergeFieldDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MergeFieldDto, unknown, Types.ImportMergeFieldDto, TContext> {
  const key = importMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.ImportMergeFieldDto) => Client.import_(dto),
    mutationKey: key,
  });
}
  
export function getQueriesUrl(): string {
  let url_ = getBaseUrl() + "/api/document/merge-fields/queries";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getQueriesDefaultOptions: Omit<UseQueryOptions<Types.DocumentQueryDto[], unknown, Types.DocumentQueryDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DocumentQueryDto[], unknown, Types.DocumentQueryDto[]>, 'queryFn'>> = {
};
export function getGetQueriesDefaultOptions() {
  return getQueriesDefaultOptions;
};
export function setGetQueriesDefaultOptions(options: typeof getQueriesDefaultOptions) {
  getQueriesDefaultOptions = options;
}

export function getQueriesQueryKey(): QueryKey;
export function getQueriesQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'MergeFieldClient',
      'getQueries',
    ]);
}
export function __getQueries(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getQueries(
axiosConfig    );
}

/**
 * Returns the list of base queries that User can query
 */
export function useGetQueriesQuery<TSelectData = Types.DocumentQueryDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.DocumentQueryDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQueriesQuery<TSelectData = Types.DocumentQueryDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DocumentQueryDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DocumentQueryDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getQueries(context, axiosConfig) : __getQueries,
    queryKey: getQueriesQueryKey(),
    ...getQueriesDefaultOptions as unknown as Omit<UseQueryOptions<Types.DocumentQueryDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns the list of base queries that User can query
 */
export function setGetQueriesData(queryClient: QueryClient, updater: (data: Types.DocumentQueryDto[] | undefined) => Types.DocumentQueryDto[], ) {
  queryClient.setQueryData(getQueriesQueryKey(),
    updater
  );
}

/**
 * Returns the list of base queries that User can query
 */
export function setGetQueriesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DocumentQueryDto[] | undefined) => Types.DocumentQueryDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function executeQueryUrl(): string {
  let url_ = getBaseUrl() + "/api/document/merge-fields/execute";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function executeQueryMutationKey(): MutationKey {
  return trimArrayEnd([
      'MergeFieldClient',
      'executeQuery',
    ]);
}

/**
 * Executed the query and return result row
 */
export function useExecuteQueryMutation<TContext>(options?: Omit<UseMutationOptions<any, unknown, Types.ExecuteQueryDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<any, unknown, Types.ExecuteQueryDto, TContext> {
  const key = executeQueryMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.ExecuteQueryDto) => Client.executeQuery(dto),
    mutationKey: key,
  });
}